<app-abstract-dialog [dialogWidth]="'800'">
    <h3 abstract-header class="abstract-dialog__header__title">{{'PROJECT.LANDING_PAGE.BAYER_POPUP_TITLE' | translate}}</h3>

    <ng-container abstract-content>
        <div class="abstract-dialog__content__image">
            <img src="{{image}}" alt="Bayer image">
        </div>
        <p class="abstract-dialog__content__text" [innerHTML]="'PROJECT.LANDING_PAGE.BAYER_POPUP_DESCRIPTION' | translate"></p>
    </ng-container>
</app-abstract-dialog>
